/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ThemeFromJSON, ThemeToJSON, } from './Theme';
/**
 * Check if a given object implements the ThemeList interface.
 */
export function instanceOfThemeList(value) {
    return true;
}
export function ThemeListFromJSON(json) {
    return ThemeListFromJSONTyped(json, false);
}
export function ThemeListFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'light': json['light'] == null ? undefined : ThemeFromJSON(json['light']),
        'dark': json['dark'] == null ? undefined : ThemeFromJSON(json['dark']),
    };
}
export function ThemeListToJSON(json) {
    return ThemeListToJSONTyped(json, false);
}
export function ThemeListToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'light': ThemeToJSON(value['light']),
        'dark': ThemeToJSON(value['dark']),
    };
}
